class LoadSDK {
	constructor() {}

	// 微信小程序
	fromWX() {
		let wxurl = 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js';
		this._addSDK(wxurl);
	}

	// 百度小程序
	fromBD() {
		let bdurl =
			'https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-1.7.0.js';
		this._addSDK(bdurl);
	}

	// 头条小程序
	fromTT() {
		let tturl = 'https://s3.pstatp.com/toutiao/tmajssdk/jssdk.js';
		this._addSDK(tturl);
	}

	// 支付宝小程序
	fromZFB() {
		let zfbUrl = 'https://appx/web-view.min.js';
		this._addSDK(zfbUrl);
	}

	// 同镇
	fromTZ() {
		// 加native协议
		let tzurl = 'https://a.58cdn.com.cn/app58/rms/app/js/app_30805.js';
		this._addSDK(tzurl);
	}

	// 加载对应的sdk
	_addSDK(url) {
		let scriptDom = document.createElement('script');
		scriptDom.type = 'text/javascript';
		scriptDom.src = url;
		document.getElementsByTagName('body')[0].appendChild(scriptDom);
	}
}

export { LoadSDK };



// WEBPACK FOOTER //
// ./src/module/basic/components/basic/LoadSDK.js